<template>
  <el-dialog
    v-model="dialogStatus"
    :close-on-click-modal="false"
    @close="close"
    :title="dialogTitle"
    :width="width"
    append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <el-form-item label="渠道" prop="channelId">
        <el-select v-model="form.channelId" placeholder="请选择渠道" size="medium" filterable style="width: 100%" @change="handleChannelChange">
          <el-option
            v-for="item in channelList"
            :key="item.id"
            :label="item.channelName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="转化任务" prop="taskId">
        <el-select v-model="form.taskId" placeholder="请选择转化任务" size="medium" filterable style="width: 100%" :disabled="!form.channelId">
          <el-option
            v-for="item in taskList"
            :key="item.id"
            :label="item.taskName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="渠道RTA名称" prop="rtaName">
        <el-input v-model="form.rtaName" size="medium" placeholder="请输入渠道RTA服务名称"/>
      </el-form-item>
      <el-form-item label="状态" prop="status">
        <el-select v-model="form.status" placeholder="请选择状态" size="medium" style="width: 100%">
          <el-option label="禁用" :value="0" />
          <el-option label="启用" :value="1" />
        </el-select>
      </el-form-item>
      <el-form-item label="备注说明" prop="remark">
        <el-input 
          v-model="form.remark" 
          type="textarea" 
          :rows="3"
          size="medium" 
          placeholder="请输入备注说明"
          maxlength="500"
          show-word-limit/>
      </el-form-item>
    </el-form>
    <div style="text-align: right;">
      <el-button @click="close" size="medium">取消</el-button>
      <el-button @click="submit" type="primary" size="medium" :loading="submitLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { addChannelRta, updateChannelRta } from '@/api/ocpx/channelRta'
import { getEnabledChannelList } from '@/api/ocpx/channel'
import { getConversionTaskListByChannelId } from '@/api/ocpx/conversionTask'

const defaultForm = {
  channelId: undefined,
  taskId: undefined,
  rtaName: undefined,
  status: 1,
  remark: undefined
}

export default {
  props: {
    title: String,
    width: {
      type: Number,
      default: 700
    }
  },
  emits: ['submit'],
  data () {
    return {
      dialogStatus: false,
      submitLoading: false,
      form: Object.assign({}, defaultForm),
      channelList: [],
      taskList: [],
      rules: {
        channelId: [{ required: true, message: '请选择渠道', trigger: 'change' }],
        taskId: [{ required: true, message: '请选择转化任务', trigger: 'change' }],
        rtaName: [{ required: true, message: '请输入渠道RTA服务名称', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  computed: {
    dialogTitle () {
      return (this.title ? this.title : '') + (this.form.id ? '编辑' : '新增')
    }
  },
  methods: {
    show (data) {
      this.dialogStatus = true
      this.loadChannelList()
      if (data) {
        this.form = Object.assign({}, data)
        // 如果有渠道ID，加载对应的任务列表
        if (data.channelId) {
          this.loadTaskList(data.channelId)
        }
      } else {
        // 新增模式，清空表单
        this.reset()
      }
    },
    loadChannelList () {
      getEnabledChannelList().then(res => {
        if (res.code === 200) {
          this.channelList = res.data || []
        }
      })
    },
    loadTaskList (channelId) {
      if (!channelId) {
        this.taskList = []
        return
      }
      // 根据渠道ID加载对应的转化任务列表
      getConversionTaskListByChannelId(channelId).then(res => {
        if (res.code === 200) {
          this.taskList = res.data || []
        }
      })
    },
    handleChannelChange (channelId) {
      // 渠道变化时，清空任务选择并重新加载任务列表
      this.form.taskId = undefined
      this.loadTaskList(channelId)
    },
    close () {
      this.dialogStatus = false
      this.reset()
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.form.id) {
            this.doUpdate(this.form)
          } else {
            this.doAdd(this.form)
          }
        }
      })
    },
    doAdd (form) {
      this.submitLoading = true
      addChannelRta(form).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    doUpdate (form) {
      this.submitLoading = true
      updateChannelRta(form).then(res => {
        if (res.code === 200) {
          this.$message.success('编辑成功')
          this.$emit('submit')
          this.close()
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    reset () {
      this.form = Object.assign({}, defaultForm)
      this.$refs.form && this.$refs.form.resetFields()
    }
  }
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 15px;
}
</style>
